import { useState, useEffect } from 'react';
import { fromEvent } from 'rxjs';
import { map } from 'rxjs/operators';

// TODO should be refactored to use pure Tailwind. Remove rxjs dependency when done
const useResponsiveView = () => {
  const [width, setWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    const resizeEvent = fromEvent(window, 'resize');
    const windowWidth = resizeEvent.pipe(map((event) => (event.target as any).innerWidth));
    const subscription = windowWidth.subscribe((width) => {
      setWidth(width);
    });
    return () => {
        subscription.unsubscribe();
    };
  }, []);

  return { width };
};

export { useResponsiveView };
